import NavigationBar from '@/components/navigation-bar';
import Error404 from '@/modules/core/routes/error-404';
import { CatchNotFound, createFileRoute, Outlet } from '@tanstack/react-router';
import { TirecloudUI } from '@thisisdmg/tirecloud-patterns/v2';
import classes from './index.module.css';
import VersionInfoModal from '@/components/version-info-modal';
import { useState } from 'react';
import { ConfigProvider, theme } from 'antd';

function NavigationBarContent() {
  const [showVersionInfo, setShowVersionInfo] = useState(false);

  return (
    <>
      <NavigationBar
        data-theme="dark"
        onVersionInfoClick={() => {
          setShowVersionInfo(true);
        }}
      />
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
        }}
      >
        <VersionInfoModal
          open={showVersionInfo}
          onClose={() => setShowVersionInfo(false)}
        />
      </ConfigProvider>
    </>
  );
}

function TirecloudUITemplate() {
  return (
    <>
      <TirecloudUI
        className={classes.main_ui}
        navigationBar={() => <NavigationBarContent />}
      >
        <TirecloudUI.Content
          showContentToggle={false}
          allowBaseOpenOnMobile={false}
        >
          <main className={classes.main_ui__content}>
            <CatchNotFound fallback={() => <Error404 />}>
              <Outlet />
            </CatchNotFound>
          </main>
        </TirecloudUI.Content>
      </TirecloudUI>
    </>
  );
}

export const Route = createFileRoute('/_main-ui')({
  component: TirecloudUITemplate,
});
